export default "__VITE_ASSET__DTk5AzL9__"